import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import {
  Button,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane
} from 'reactstrap';
import { isPermitted, permissions } from '../permissions';
import { displayError } from '../utilities';
import RunSlotCreationJob from './RunSlotCreationJob';
import SlotProtoContainer from './SlotProtoContainer';
import SlotPrototypeFormModal from './SlotPrototypeFormModal';
import DocForm from './docForm';
import EducationExperienceForm from './EduAndExpTab';

const tabs = {
  info: 'info',
  education: 'education',
  timing: 'timing'
};

const DoctorEditTabs = ({ doctor, departments, specializations }) => {
  const [selectedTab, setSelectedTab] = useState(tabs.info);
  const [isEditSlotprotoModalOpen, toggleEditSlotprotoModal] = useState(false);
  const [editSlotPrototypeId, setEditSlotPrototypeId] = useState(null);

  const { entityId, name, aboutMe, profileStatus } = doctor;

  return (
    <>
      <h2>{name}</h2>
      <Nav tabs style={{ marginBottom: '1rem' }}>
        <NavItem>
          <NavLink
            style={{
              fontWeight: selectedTab === tabs.info ? 'bold' : 'normal'
            }}
            className={classnames({
              activeTab: selectedTab === tabs.info,
              active: selectedTab === tabs.info,
              inactiveTab: selectedTab !== tabs.info
            })}
            onClick={() => setSelectedTab(tabs.info)}
          >
            PERSONAL INFO
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            style={{
              fontWeight: selectedTab === tabs.education ? 'bold' : 'normal'
            }}
            className={classnames({
              activeTab: selectedTab === tabs.education,
              active: selectedTab === tabs.education,
              inactiveTab: selectedTab !== tabs.education
            })}
            onClick={() => setSelectedTab(tabs.education)}
          >
            EDUCATION & EXPERIENCE
          </NavLink>
        </NavItem>
        {isPermitted(permissions.CAN_VIEW_SLOT_PROTO) && (
          <NavItem>
            <NavLink
              style={{
                fontWeight: selectedTab === tabs.timing ? 'bold' : 'normal'
              }}
              className={classnames({
                activeTab: selectedTab === tabs.timing,
                active: selectedTab === tabs.timing,
                inactiveTab: selectedTab !== tabs.timing
              })}
              onClick={() => setSelectedTab(tabs.timing)}
            >
              SCHEDULE
            </NavLink>
          </NavItem>
        )}
      </Nav>
      <TabContent activeTab={selectedTab}>
        <TabPane tabId={tabs.info}>
          <Row>
            <Col sm="12">
              <DocForm
                doc={doctor}
                departments={departments}
                className="doc-form"
              />
            </Col>
          </Row>
        </TabPane>
        <TabPane tabId={tabs.education}>
          <Row>
            <Col>
              <EducationExperienceForm
                doctor={doctor}
                departments={departments}
                specializations={specializations}
              />
            </Col>
          </Row>
        </TabPane>
        {isPermitted(permissions.CAN_VIEW_SLOT_PROTO) && (
          <TabPane tabId={tabs.timing}>
            <Row>
              <Col>
                <div className="d-flex justify-content-end">
                  <RunSlotCreationJob
                    entityId={entityId}
                    aboutMe={aboutMe}
                    profileStatus={profileStatus}
                  />
                  <Button
                    size="sm"
                    color="primary"
                    onClick={() => {
                      if (!aboutMe || aboutMe.trim().length < 100) {
                        displayError(
                          `About Me field should have minimum 100 characters`
                        );
                        return;
                      }
                      if (profileStatus !== 'approved') {
                        displayError(
                          'Doctor is not yet approved to create schedule'
                        );
                        return;
                      }
                      setEditSlotPrototypeId(null);
                      toggleEditSlotprotoModal(true);
                    }}
                  >
                    Add New Schedule
                  </Button>
                </div>
              </Col>
            </Row>

            <SlotProtoContainer
              entityId={entityId}
              onEdit={slotPrototypeId => {
                setEditSlotPrototypeId(slotPrototypeId);
                toggleEditSlotprotoModal(true);
              }}
            />

            <SlotPrototypeFormModal
              entityId={entityId}
              slotPrototypeId={editSlotPrototypeId}
              isOpen={isEditSlotprotoModalOpen}
              toggle={() => toggleEditSlotprotoModal(!isEditSlotprotoModalOpen)}
              name={name}
            />
          </TabPane>
        )}
      </TabContent>
    </>
  );
};

DoctorEditTabs.propTypes = {
  doctor: PropTypes.object.isRequired,
  departments: PropTypes.arrayOf(PropTypes.object).isRequired,
  specializations: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default DoctorEditTabs;
